export class InputValidator {

    static emptyFieldDefaultMessage: string = "Please fill in this field";

    static isValidEmail(value: string): boolean {
        const emailRegex = /^(?:[a-z0-9!#$%&'*+\/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+\/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?)/i;
        return emailRegex.test(value.trim());
    }

    static hasNoHtmlTags(value: string): boolean {
        const htmlRegex = /[\[<>;:/\\\]]/i;
        return !htmlRegex.test(value.trim());
    }
}
